<script setup lang="ts">
/**
 * InterviewEventBanner — 면접 로드맵 무료 이벤트(081) 진입 띠. 홈 히어로 위 전폭(`variant="strip"`)과
 * 면접 상품 화면 상단(`variant="inline"`, 라운드 카드) 두 곳에서 쓴다.
 *
 * 노출 조건(`commerce.isFreeEventOpen`)은 부모가 판정한다 — 여기서는 표시만. 기간이 지나면 서버 신호가
 * 닫혀 렌더 자체가 사라진다(재배포 불요, FR-019). 문구 SSoT 는 config/interviewEvent.ts.
 * 050 합격컷 배너(EventBanner)와 독립이다.
 */
import { ArrowRight, CircleCheck } from 'lucide-vue-next';
import { RouterLink } from 'vue-router';

import {
  INTERVIEW_EVENT_COPY as COPY,
  INTERVIEW_EVENT_DEADLINE,
  INTERVIEW_EVENT_PATH,
} from '#/config/interviewEvent';

defineOptions({ name: 'InterviewEventBanner' });

withDefaults(defineProps<{ variant?: 'strip' | 'inline' }>(), { variant: 'strip' });
</script>

<template>
  <!-- ⚠️ `block` 클래스 금지 — HomePage scoped `.block` 섹션 아톰과 충돌(EventBanner 동일 사유). -->
  <RouterLink
    :to="INTERVIEW_EVENT_PATH"
    class="hover:bg-accent-line/40 flex border-accent-line bg-accent-soft transition-colors"
    :class="variant === 'strip' ? 'border-b' : 'mb-6 rounded-card border'"
  >
    <div
      class="flex w-full flex-wrap items-center justify-center gap-x-3 gap-y-1 py-[10px]"
      :class="variant === 'strip' ? 'mx-auto max-w-page px-4 md:px-8' : 'px-4'"
    >
      <span
        class="inline-flex items-center gap-[6px] text-[12.5px] font-extrabold tracking-[-0.01em] text-accent-deep md:text-[13.5px]"
      >
        <CircleCheck :size="15" :stroke-width="2.2" />
        {{ COPY.bannerLabel }}
      </span>
      <span class="text-[12.5px] font-semibold text-brand md:text-[13.5px]">
        {{ variant === 'strip' ? COPY.bannerBody : COPY.stripBody }} ·
        {{ INTERVIEW_EVENT_DEADLINE }}
      </span>
      <span
        class="inline-flex items-center gap-[3px] text-[12.5px] font-extrabold text-brand underline underline-offset-4 md:text-[13px]"
      >
        {{ COPY.more }}
        <ArrowRight :size="14" :stroke-width="2.2" />
      </span>
    </div>
  </RouterLink>
</template>
